import {takeEvery, put, call} from 'redux-saga/effects';
import {makeQuery} from "../../../apis";
import {setChartQuery} from "../../../slices/chart/chart";
import {SMETA_TAB} from "../../../types/smeta/smetaTab/smetaTab";
import {setSmetaTabData, setSmetaTabLoading, setSmetaTabError} from "../../../slices/smeta/smetaTab/smetaTab";


export function* sendSmetaTabSaga({bodyData}) {
    try {
        yield put(setSmetaTabLoading(true));
        const result = yield call(makeQuery, bodyData);
        yield put(setSmetaTabData(result));
        yield put(setChartQuery(bodyData));
        yield put(setSmetaTabLoading(false));
        yield put(setSmetaTabError({}));
    } catch (e) {
        yield put(setSmetaTabError(e.response.data.error));
        yield put(setSmetaTabLoading(false));
    }
}


export function* watchSmetaTab() {
    yield takeEvery(SMETA_TAB, sendSmetaTabSaga);
}